import React from "react";
import {Drawer, Form, Button, Col, Row, Input, Select} from 'antd';
import { LoadDataAnyEndpoint} from "../../../api/fn";
import moment from "moment";
import {GetUserToken} from "../../../api/token";


const {Option} = Select;

const makeCol = (row, _this) => {
    let { handleChangeInput} = _this;
    if (row === null) {
        return null;
    }
    if (row.datatype === "list" || row.datatype === "option") {
        let options = row.options;
        /*for (let i in row.options) {
            const key = i;
            const val = i;
            options.push({
                key: key,
                val: val,
            })
        }*/
        return (
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.label}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <Select
                        placeholder={"Please enter user " + row.label}
                        onChange={(e) => handleChangeInput(e, row.fieldname)}
                    >
                        {options.map(rec => {
                            return (
                                <Option value={rec.key}>{rec.val}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            </Col>
        )
    }
    return (
        <Col span={12}>
            <Form.Item
                name={row.fieldname}
                label={row.label}
                rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
            >
                <Input
                    placeholder={"Please enter " + row.label}
                    onChange={(e) => handleChangeInput(e.target.value, row.fieldname)}
                />
            </Form.Item>
        </Col>
    )
}

export default class NewLeadDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            selectedPriority:"",
            newEntry:{},
        }
    }

    handleChange = async (e, key) => {
        const value = e.value;
        this.setState({
            [key]: value,
        });

    }
    handleChangeInput=(val,key)=>{
        let tmp=this.state;
        tmp.newEntry[key]=val;
        this.setState(tmp);
    }

    onSubmit=async ()=>{
        if (!window.confirm("Are you sure to submit this record!")) {
            return
        }
        /*if(this.state.selectedPriority===""){
            return alert("sorry please select")
        }


        if (!window.confirm("Are you sure to submit this record!")) {
            return
        }*/
        let self=this;
        let {_this } = this.props;
        let {state, handleChangeInput, handleChangeInput2} = _this;

        let {org,project} = this.props._this.getInfo();


        let fieldsList = this.getAttributes();


        let o = {};
        for (let i in fieldsList) {
            const row = fieldsList[i];
            const key = row.fieldname;
            let val = this.state.newEntry[key];
            const type =row.datatype;
            if (type === "float") {
                //val = parseFloat(val)
            } else if (type === "number") {
                //val = parseInt(val)
            } else if (type === "boolean") {
                val = val === "yes"
            } else {
                //todo do nothing
            }
            o[key] = val;
        }



        let hub = {
            ...o,
            Org: org,
            project: project,
        }


        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = {}
        let endpoint = "/common/entity/Callbacks/insert"; // "/manager/entity/insert/extensions";

        console.log("onSubmit new priority send 2 > ", post);

        await LoadDataAnyEndpoint(post, endpoint, "Data", this,async (dataOut) => {
            console.log("onSubmit new priority response > ", dataOut);
            self.onClose();
            _this.setState({
                newEntry:{},
            });
            _this.loadInitialData();
            //await SubmitLogInformation(org,project,"status","all",self.state.selectedStatus,data.record.ref,o,self)
            alert("Thank you record added!")

        });

    }

    getAttributes=()=>{
        let ls=[
            {fieldname: "phone", datatype: "string", required: true, label: "Phone Number", options: []},
            {fieldname: "email", datatype: "string", required: false, label: "Email", options: []},
            {
                fieldname: "contactperson",
                dataType: "string",
                required: true,
                label: "Contact Person",
                options: []
            },
            {fieldname: "subject", datatype: "string", required: true, label: "Subject", options: []},
            {fieldname: "Reason", datatype: "option", required: true, label: "Reason", options: this.props._this.getReason()},
            {fieldname: "message", datatype: "string", required: true, label: "Message", options: []},
            {fieldname: "address", datatype: "string", required: false, label: "Address", options: []},
            {fieldname: "city", datatype: "string", required: false, label: "City", options: []},
            {fieldname: "province", datatype: "string", required: false, label: "Province", options: []},
            {fieldname: "region", datatype: "string", required: false, label: "Region", options: []},
            {
                fieldname: "assignto",
                datatype: "option",
                required: false,
                label: "Assign To",
                options: this.props._this.getUsers()
            },

        ];

        return ls

    }
    getTitle=()=>{
        /*let {_this } = this.props;
        let {state} = _this;
        if(state.ActionData!==null){
            return state.ActionData.name;
        }*/
        return "----"
    }
    onClose=()=>{
        let {_this } = this.props;
        _this.setState({
            showActionLead:false,
        })
    }

    render() {
        let {_this } = this.props;
        let {state} = _this;
        let attributes = this.getAttributes()

        let ls = [];
        let loopIndex = 0;
        for (let i = 0; i < attributes.length; i += 2) {
            loopIndex = i;
            const row = attributes[i];
            let row2 = null;
            let nextIndex = i + 1;
            if (nextIndex < (attributes.length)) {
                row2 = attributes[nextIndex]
            }
            ls.push(
                <Row gutter={16}>
                    {makeCol(row, this)}
                    {makeCol(row2, this)}
                </Row>
            );
            console.log("Loop ::::--> ", i, " > ", row.fieldname)
        }

        return (
            <>
                <Drawer
                    title={"Create a new lead"}
                    width={720}
                    onClose={this.onClose}
                    visible={state.showActionLead}
                    bodyStyle={{paddingBottom: 80}}
                    footer={
                        <div
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <Button onClick={this.onClose} style={{marginRight: 8}}>
                                Cancel
                            </Button>
                            <Button onClick={this.onSubmit} type="primary">
                                Submit
                            </Button>
                        </div>
                    }
                >

                    <Form layout="vertical" hideRequiredMark>
                        {ls.map(row => {
                            return row;
                        })}

                    </Form>
                </Drawer>
            </>
        )
    }
}
